<template>
  <main-content>
    <component :is="selectedComponent"></component>
  </main-content>
</template>

<script>
import mainContent from '@/components/main-content'
import coreTransactions from './components/core-transactions.vue';
import coreTransactionsMonitoring from './components/core-transactions-monitoring.vue';
import starshopTransactions from './components/starshop-transactions.vue';
import notificationsSetting from './components/notifications-setting.vue';

export default {

  components: {
    mainContent,
    coreTransactions,
    coreTransactionsMonitoring,
    starshopTransactions,
    notificationsSetting
  },

  computed: {
    selectedComponent() {
      console.log(this.$route.path);
      if (this.$route.path.includes('pardakhtyari')) {
        return 'core-transactions'
      }
      else if(this.$route.path.includes('monitoring')) {
        return 'core-transactions-monitoring'
      }
      else if (this.$route.path.includes('starshop')) {
        return 'starshop-transactions'
      }
      else if(this.$route.path.includes('notifications-setting')) {
        return 'notifications-setting'
      }
    }
  }

}
</script>

<style>
.kt-datatable__cell {
  font-size: .9rem !important;
}

.kt-datatable.kt-datatable--default>.kt-datatable__table>.kt-datatable__body .kt-datatable__row>.kt-datatable__cell,
.kt-datatable.kt-datatable--default>.kt-datatable__table>.kt-datatable__head .kt-datatable__row>.kt-datatable__cell.kt-datatable__cell--sort {
  padding: 8px !important;
}

.kt-datatable.kt-datatable--default>.kt-datatable__table>.kt-datatable__body .kt-datatable__row>.kt-datatable__cell:first-child,
.kt-datatable.kt-datatable--default>.kt-datatable__table>.kt-datatable__head .kt-datatable__row>.kt-datatable__cell:first-child {
  padding-right: 20px !important;
}
</style>